/**
 * Opens a dialog from a dropdown-menu item without freezing the page.
 *
 * Radix menus are modal: they set `pointer-events: none` on <body> and
 * restore it when they unmount. A Dialog opened synchronously inside
 * `onSelect` mounts while the menu is still closing, snapshots the locked
 * body style as "the value to restore", and leaves the page unclickable
 * when it closes. Running the open on the next macrotask lets the menu
 * finish first.
 */
export const afterMenuClose = (fn: () => void): void => {
	window.setTimeout(fn, 0);
};
